module.exports = __webpack_public_path__ + "static/media/settings.f7d85c75.svg";